import { useTranslation, Translation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
import cx from 'clsx';

import styles from './index.module.scss';
import { TrendingOfficials } from './components/TrendingOfficials';
import { NavLink } from '@/components';
import { NewlyOfficials } from './components/NewlyOfficialAccount';

const TABS = [
  {
    mode: 'newly',
    label: <Translation>{t => t('OfficialAccounts.195r16k')}</Translation>,
  },
  {
    mode: 'trending',
    label: <Translation>{t => t('OfficialAccounts.o50abp')}</Translation>,
  },
];

export const OfficialAccounts = () => {
  const { t } = useTranslation();

  const [mode, setMode] = useState('newly');

  const handleTabClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      const { mode: m } = e.currentTarget.dataset;
      if (m && m !== mode) {
        setMode(m);
      }
    },
    [mode],
  );

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('OfficialAccounts.ynzhfc')}</div>
      <div className={styles.tabContainer}>
        <div className={styles.tabs}>
          {TABS.map(x => (
            <div
              className={styles.tabItem}
              key={x.mode}
              data-mode={x.mode}
              onClick={handleTabClick}>
              <div className={cx(styles.tabInner, mode === x.mode && styles.isSelected)}>
                {x.label}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.listContainer}>
        {mode === 'newly' ? <NewlyOfficials /> : null}
        {mode === 'trending' ? <TrendingOfficials /> : null}
      </div>
      <NavLink to="/official-ranking" className={styles.rankingLink} target="_blank">
        {t('OfficialAccounts.1w1zr3b')}
      </NavLink>
    </div>
  );
};
